import React, {Component} from 'react';

class DesignSaveStatus extends Component {
    constructor(props) {
        super(props);
        this.state = {
            designStatusText: 'All changes saved'
        }
    }

    setDesignStatusText = (text) => {
        this.setState({designStatusText: text})
    }

    componentDidMount() {
        window.setDesignStatusText = this.setDesignStatusText;
    }

    componentWillUnmount() {

    }

    render() {
        return (
            <span className="design_save_status_text" style={{float: 'left', 'marginLeft':'10px','marginTop':'3px','paddingTop':'8px',marginRight:'20px'}}>{this.state.designStatusText} &nbsp;&nbsp;</span>
        )
    }
}

export default DesignSaveStatus;